import { t } from "app/utils";
import { useEventStartingListener } from "./useListener";

const getMessage = ({ name, startsAt, location }) => {
  let message = t(`${name} is starting at ${new Date(startsAt).toLocaleTimeString()}`);

  if (location) {
    message = t(`${message} at ${location}`);
  }

  return message;
};

// eslint-disable-next-line no-alert
const onEventStarting = event => window.alert(getMessage(event));
const useEventStartingAlert = () => useEventStartingListener(onEventStarting);

export default useEventStartingAlert;
